import React from "react";
import { motivationalVideosReducer } from "store/reducers/motivationalVideosReducer";
import { motivationalVideosState } from "store/reducers/motivationalVideosReducer";
import { useReducer } from "react";
import Mindfulness from "components/Mindfullness/Mindfulness";
import { useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from 'react-router-dom';

const MindfulnessPage = (props) => {
  const { pathname } = useLocation();
  const params = useParams();
  const initialActiveTab = pathname.includes('training-documents') ? 3 : pathname.includes('training-videos') ? 2 : 0;
  const [{ ...state }, dispatch] = useReducer(
    motivationalVideosReducer,
    { ...motivationalVideosState, activeTab: initialActiveTab }
  );
  const { search } = props.location;

  useEffect(() => {
    const tabTypeSq = new URLSearchParams(search).get("tab");
    const typeMap = {
      cc: 2,
      me: 1,
      mo: 0,
    };

    let tabValue = -1;
    if (tabTypeSq && typeMap[tabTypeSq] !== undefined) {
      tabValue = typeMap[tabTypeSq];
    } else if (pathname.includes('training-documents')) {
      tabValue = 3;
    } else if (pathname.includes('training-videos')) {
      tabValue = 2;
    } else if (pathname.includes('motivational-videos')) {
      tabValue = 0;
    }

    if (tabValue !== -1) {
      dispatch({
        type: "setActiveTab",
        value: tabValue,
      });
    }
  }, [pathname, search]);

  useEffect(() => {
    dispatch({ type: "teamIdUpdated", value: params.teamId });
    return () => {
      dispatch({
        type: "clearVideoState",
      });
    };
  }, [params.teamId]);

  return (
    <div>
      <Mindfulness {...state} dispatch={dispatch} />
    </div>
  );
};

export default MindfulnessPage;
